// extracted by mini-css-extract-plugin
export default {"center":"ClarificationDemoVoice_center__z794T","centerText":"ClarificationDemoVoice_centerText__DRUg6","fadeIn":"ClarificationDemoVoice_fadeIn__-zq33"};